import secureLocalStorage from "react-secure-storage";
import { formatNumber } from "@telerik/kendo-intl";
import * as React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
export default class CurrencyFormat extends React.Component {
  handleChange = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.value,
    });
  };
  handleEditCell = () => {
    this.props.onEditCell(this.props.dataItem, this.props.field);
  };
  render() {
    const { dataItem, field } = this.props;
    const dataValue =
      dataItem[field] === null || dataItem[field] === undefined
        ? 0
        : dataItem[field];
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <NumericTextBox
            defaultValue={dataValue}
            onChange={this.handleChange}
          />
        </td>
      );
    } else {
      return secureLocalStorage.getItem("role") === "Standard User" ||
        secureLocalStorage.getItem("role") === "View Only" ? (
        <td>{dataItem[field]?formatNumber(dataValue, "##,#"):""}</td>
      ) : (
        <td onClick={this.handleEditCell}>{dataItem[field] || dataItem[field]===0 ?formatNumber(dataValue, "##,#"):""}</td>
      );
    }
  }
}
